
import  { useEffect } from 'react';
import { connect } from 'react-redux';
import {setLanguage} from "../Redux/Actions/languageActions"
import i18n from '../i18n';

const LanguageContainer = ({ setLanguage }) => {
  useEffect(() => {
    // Détecter la langue du navigateur
    const detectedLanguage = navigator.language.split('-')[0] ; 
    // Mettre la langue dans Redux
    setLanguage(detectedLanguage);
    // Mettre à jour i18n
    i18n.changeLanguage(detectedLanguage);
  }, []);
};


const mapDispatchToProps = (dispatch) => ({
    setLanguage: (language) => dispatch(setLanguage(language)), 
});

export default connect(null, mapDispatchToProps)(LanguageContainer);